export const DASHBOARD_DATA_STATUS = Object.freeze({
  VERIFIED: "verified",
  CACHED: "cached",
  UNAVAILABLE: "unavailable",
});

export const DASHBOARD_DATA_KEYS = Object.freeze([
  "businessMetrics",
  "totals",
  "salesPurchasesChart",
  "topSellingProducts",
  "topCustomers",
  "stockAlerts",
  "paymentsChart",
  "grossMargin",
  "averageOrderValue",
  "stockTurnover",
  "expenseBreakdown",
  "stockValuation",
]);

export const createDashboardDataStatuses = (
  status = DASHBOARD_DATA_STATUS.UNAVAILABLE,
  details = {},
) =>
  DASHBOARD_DATA_KEYS.reduce((accumulator, key) => {
    accumulator[key] = {
      status,
      updatedAt: details.updatedAt ?? null,
      message: details.message ?? null,
    };
    return accumulator;
  }, {});

export const buildDashboardDatasetStatus = ({
  value,
  sourceStatus,
  updatedAt = null,
  message = null,
}) => {
  const unavailable =
    value === null || value === undefined || value?._fallback === true;

  if (unavailable || sourceStatus === DASHBOARD_DATA_STATUS.UNAVAILABLE) {
    return {
      status: DASHBOARD_DATA_STATUS.UNAVAILABLE,
      updatedAt: null,
      message:
        message ||
        (value?._fallback
          ? "Le serveur a utilisé une réponse de secours incomplète."
          : "La donnée n'a pas pu être vérifiée."),
    };
  }

  return {
    status:
      sourceStatus === DASHBOARD_DATA_STATUS.CACHED
        ? DASHBOARD_DATA_STATUS.CACHED
        : DASHBOARD_DATA_STATUS.VERIFIED,
    updatedAt,
    message,
  };
};

export const resolveDashboardMetricStatus = (datasetStatus, values) => {
  const normalizedValues = Array.isArray(values) ? values : [values];
  const hasInvalidValue = normalizedValues.some(
    (value) =>
      value === null ||
      value === undefined ||
      value === "" ||
      !Number.isFinite(Number(value)),
  );

  if (
    !datasetStatus ||
    datasetStatus.status === DASHBOARD_DATA_STATUS.UNAVAILABLE ||
    hasInvalidValue
  ) {
    return {
      status: DASHBOARD_DATA_STATUS.UNAVAILABLE,
      updatedAt: null,
      message:
        datasetStatus?.message || "La valeur n'a pas pu être vérifiée.",
    };
  }

  return datasetStatus;
};

export const isDashboardDataAvailable = (status) =>
  status?.status === DASHBOARD_DATA_STATUS.VERIFIED ||
  status?.status === DASHBOARD_DATA_STATUS.CACHED;
